import { LastName } from '@dreryk/person-name-common-api';

import { BindingCreator } from '@dreryk/react-common';
import { LastNameInput } from '@dreryk/react-components';

const LAST_NAME_FIELD_NAME = 'lastName';
const LAST_NAME_MAX_LENGTH = 50;

export type LastNameFormBeanPart = {
   [LAST_NAME_FIELD_NAME]: LastName | null;
};

type LastNameFieldProps = {
   readonly register: BindingCreator<LastNameFormBeanPart, typeof LAST_NAME_FIELD_NAME>;
};

export const LastNameField = (props: LastNameFieldProps): JSX.Element => {
   return (
      <LastNameInput
         controller={props.register(LAST_NAME_FIELD_NAME, {
            required: true,
            /*
             * TODO: DREGAB-19275 - Poprawa walidacji tak by populowała walidacje z wnętrza komponentu
             * react-components i nie trzeba było ich powtarzać ponownie podczas rejestracji pola
             */
            maxLength: LAST_NAME_MAX_LENGTH,
         })}
         testId={LAST_NAME_FIELD_NAME}
      />
   );
};
